import { CALL_API } from '../../middleware/api';

/**
 * insert
 */
export const INSERT_AUTHORIZATION_REQUEST = 'INSERT_AUTHORIZATION_REQUEST';
export const INSERT_AUTHORIZATION_SUCCESS = 'INSERT_AUTHORIZATION_SUCCESS';
export const INSERT_AUTHORIZATION_FAILURE = 'INSERT_AUTHORIZATION_FAILURE';

/**
 * UPDATE
 */
export const UPDATE_AUTHORIZATION_REQUEST = 'UPDATE_AUTHORIZATION_REQUEST';
export const UPDATE_AUTHORIZATION_SUCCESS = 'UPDATE_AUTHORIZATION_SUCCESS';
export const UPDATE_AUTHORIZATION_FAILURE = 'UPDATE_AUTHORIZATION_FAILURE';

/**
 * Del
 */
export const DELETE_AUTHORIZATION_REQUEST = 'DELETE_AUTHORIZATION_REQUEST';
export const DELETE_AUTHORIZATION_SUCCESS = 'DELETE_AUTHORIZATION_SUCCESS';
export const DELETE_AUTHORIZATION_FAILURE = 'DELETE_AUTHORIZATION_FAILURE';

/**
 * close
 */
export const CLOSE_AUTHORIZATION_REQUEST = 'CLOSE_AUTHORIZATION_REQUEST';
export const CLOSE_AUTHORIZATION_SUCCESS = 'CLOSE_AUTHORIZATION_SUCCESS';
export const CLOSE_AUTHORIZATION_FAILURE = 'CLOSE_AUTHORIZATION_FAILURE';

/**
 * open
 */
export const OPEN_AUTHORIZATION_REQUEST = 'OPEN_AUTHORIZATION_REQUEST';
export const OPEN_AUTHORIZATION_SUCCESS = 'OPEN_AUTHORIZATION_SUCCESS';
export const OPEN_AUTHORIZATION_FAILURE = 'OPEN_AUTHORIZATION_FAILURE';

/**
 * my list
 */
export const MY_AUTHORIZATION_REQUEST = 'MY_AUTHORIZATION_REQUEST';
export const MY_AUTHORIZATION_SUCCESS = 'MY_AUTHORIZATION_SUCCESS';
export const MY_AUTHORIZATION_FAILURE = 'MY_AUTHORIZATION_FAILURE';

/**
 * 详情
 */
export const AUTHORIZATION_DETAIL_REQUEST = 'AUTHORIZATION_DETAIL_REQUEST';
export const AUTHORIZATION_DETAIL_SUCCESS = 'AUTHORIZATION_DETAIL_SUCCESS';
export const AUTHORIZATION_DETAIL_FAILURE = 'AUTHORIZATION_DETAIL_FAILURE';

/**
 * list
 */
export const AUTHORIZATION_LIST_REQUEST = 'AUTHORIZATION_LIST_REQUEST';
export const AUTHORIZATION_LIST_SUCCESS = 'AUTHORIZATION_LIST_SUCCESS';
export const AUTHORIZATION_LIST_FAILURE = 'AUTHORIZATION_LIST_FAILURE';

export function insertAuthorization(params) {
  return {
    [CALL_API]: {
      types: [INSERT_AUTHORIZATION_REQUEST, INSERT_AUTHORIZATION_SUCCESS, INSERT_AUTHORIZATION_FAILURE],
      endpoint: 'workflow/authorization/insert',
      methods: 'POST',
      params
    }
  }
}

export function updateAuthorization(params) {
  return {
    [CALL_API]: {
      types: [UPDATE_AUTHORIZATION_REQUEST, UPDATE_AUTHORIZATION_SUCCESS, UPDATE_AUTHORIZATION_FAILURE],
      endpoint: 'workflow/authorization/update',
      methods: 'POST',
      params
    }
  }
}

export function closeAuthorization(params) {
  return {
    [CALL_API]: {
      types: [CLOSE_AUTHORIZATION_REQUEST, CLOSE_AUTHORIZATION_SUCCESS, CLOSE_AUTHORIZATION_FAILURE],
      endpoint: 'workflow/authorization/close',
      methods: 'POST',
      params
    }
  }
}

export function openAuthorization(params) {
  return {
    [CALL_API]: {
      types: [OPEN_AUTHORIZATION_REQUEST, OPEN_AUTHORIZATION_SUCCESS, OPEN_AUTHORIZATION_FAILURE],
      endpoint: 'workflow/authorization/open',
      methods: 'POST',
      params
    }
  }
}

export function myAuthorization(params) {
  return {
    [CALL_API]: {
      types: [MY_AUTHORIZATION_REQUEST, MY_AUTHORIZATION_SUCCESS, MY_AUTHORIZATION_FAILURE],
      endpoint: 'workflow/authorization/my-list',
      methods: 'GET',
      params
    }
  }
}

export function deleteAuthorization(params) {
  return {
    [CALL_API]: {
      types: [DELETE_AUTHORIZATION_REQUEST, DELETE_AUTHORIZATION_SUCCESS, DELETE_AUTHORIZATION_FAILURE],
      endpoint: 'workflow/authorization/delete',
      methods: 'POST',
      params
    }
  }
}

export function authorizationDetail(params) {
  return {
    [CALL_API]: {
      types: [AUTHORIZATION_DETAIL_REQUEST, AUTHORIZATION_DETAIL_SUCCESS, AUTHORIZATION_DETAIL_FAILURE],
      endpoint: 'workflow/authorization/detail',
      methods: 'GET',
      params
    }
  }
}

export function getAuthorizationByType(params) {
  return {
    [CALL_API]: {
      types: [AUTHORIZATION_LIST_REQUEST, AUTHORIZATION_LIST_SUCCESS, AUTHORIZATION_LIST_FAILURE],
      endpoint: 'workflow/authorization/list',
      methods: 'GET',
      params
    }
  }
}





// WEBPACK FOOTER //
// ./src/action/workflow/authorization.js